/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-weather-cloudy': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M43.945 65.639c-8.835 0-15.998-7.162-15.998-15.998 0-8.836 7.163-15.998 15.998-15.998 6.004 0 11.229 3.312 13.965 8.203.664-.113 1.338-.205 2.033-.205 6.627 0 11.999 5.373 11.999 12 0 6.625-5.372 11.998-11.999 11.998H43.945zm15.998-4a8 8 0 100-15.998c-1.6 0-3.082.481-4.333 1.291-1.231-5.316-5.974-9.29-11.665-9.29-6.626 0-11.998 5.372-11.998 11.999 0 6.626 5.372 11.998 11.998 11.998h15.998z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-weather-cloudy.js